/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';

import { TalentSearchResultIcon } from '../../constants/icons/talent';

type TalentUserAvatarProps = {
	src?: string;
	isQuickFind?: boolean;
};

const styles = cssMap({
	container: {
		position: 'relative',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > svg': {
			position: 'absolute',
			bottom: '0px',
			right: '0px',
			height: '12px',
			width: '12px',
			borderColor: token('elevation.surface.overlay'),
			backgroundColor: token('elevation.surface.overlay'),
			borderWidth: token('border.width'),
			borderStyle: 'solid',
			borderRadius: token('radius.small'),
		},
	},
	quickFind: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > svg': {
			height: '10px',
			width: '10px',
		},
	},
});

export const TalentUserAvatar: ({ src, isQuickFind }: TalentUserAvatarProps) => JSX.Element = ({
	src,
	isQuickFind = false,
}: TalentUserAvatarProps) => {
	return (
		<span css={[styles.container, isQuickFind && styles.quickFind]}>
			<Avatar src={src} />
			<TalentSearchResultIcon />
		</span>
	);
};
